import { Container, Box, Typography, DialogTitle, DialogContent, Dialog, CircularProgress } from '@mui/material';
import type { MouseEvent } from 'react';
import PullerTab from '@/components/PullerTab/PullerTab';
import { Drawer } from '@/index';
import { TReview } from '@/types';
import OneReview from './OneReview';
import { IReviewsDialogOrDrawer } from './ReviewRating.helper';
import { reviewsDrawerStyles, reviewsDialogStyles, reviewsDrawerPaperStyles, pullerContainer, mobileReviewsContainerStyles, loadMoreBoxStyles } from './ReviewRating.styles';
import TAGButton from '../TAGButton';
import { CloseButton } from '../TAGDialog/TAGDialog';
const stopPropagation = (e: MouseEvent) => e.stopPropagation();
function LoadMoreFooter({
  loading,
  hasMore,
  onLoadMore
}: Readonly<{
  loading?: boolean;
  hasMore?: boolean;
  onLoadMore?: () => void;
}>) {
  if (loading) {
    return <Box display="flex" justifyContent="center" py={2} data-testid="reviews_loading">
				<CircularProgress size={24} />
			</Box>;
  }
  if (!hasMore || !onLoadMore) return null;
  return <Box sx={loadMoreBoxStyles} data-sentry-element="Box" data-sentry-component="LoadMoreFooter" data-sentry-source-file="ReviewsDialogOrDrawer.tsx">
			<TAGButton variant="secondaryDefault" size="small" onClick={onLoadMore} dataTestId="reviews_load_more_button" data-sentry-element="TAGButton" data-sentry-source-file="ReviewsDialogOrDrawer.tsx">
				Load more
			</TAGButton>
		</Box>;
}
export default function ReviewsDialogOrDrawer({
  open,
  mobileWidth,
  handleCloseDialog,
  facilityName,
  reviews,
  showFullReview = false,
  loading,
  hasMore,
  onLoadMore
}: IReviewsDialogOrDrawer) {
  if (mobileWidth) {
    return <Drawer open={open} onClose={handleCloseDialog} anchor={'bottom'} roundedTop sx={reviewsDrawerPaperStyles}>
				<Container data-testid={showFullReview ? 'Single_Review_Drawer' : 'All_Reviews_Drawer'} sx={mobileReviewsContainerStyles} onClick={stopPropagation}>
					<Box sx={pullerContainer}>
						<PullerTab position="absolute" />
					</Box>
					<CloseButton onClose={handleCloseDialog} />
					<Typography variant="header2" sx={reviewsDrawerStyles} data-testid={showFullReview ? 'Single_Review_Drawer_Title' : 'All_Reviews_Drawer_Title'}>
						{facilityName}
					</Typography>
					{reviews.map((review: TReview) => <OneReview dataTestId={`mobile_${review.reviewId}`} key={`mobile-${review.reviewId}`} review={review} showFullReview={showFullReview} mobileWidth />)}
					<LoadMoreFooter loading={loading} hasMore={hasMore} onLoadMore={onLoadMore} />
				</Container>
			</Drawer>;
  }
  return <Dialog onClose={handleCloseDialog} open={open} fullWidth maxWidth="md" sx={reviewsDialogStyles} data-testid={showFullReview ? 'Single_Review_Dialog' : 'All_Reviews_Dialog'} data-sentry-element="Dialog" data-sentry-component="ReviewsDialogOrDrawer" data-sentry-source-file="ReviewsDialogOrDrawer.tsx">
			<CloseButton onClose={handleCloseDialog} data-sentry-element="CloseButton" data-sentry-source-file="ReviewsDialogOrDrawer.tsx" />
			<DialogTitle variant="header2" data-testid={showFullReview ? 'Single_Review_Dialog_Title' : 'All_Reviews_Dialog_Title'} data-sentry-element="DialogTitle" data-sentry-source-file="ReviewsDialogOrDrawer.tsx">
				{facilityName}
			</DialogTitle>

			<DialogContent data-sentry-element="DialogContent" data-sentry-source-file="ReviewsDialogOrDrawer.tsx">
				{reviews.map((review: TReview) => <OneReview dataTestId={`desktop_${review.reviewId}`} key={`desktop-${review.reviewId}`} review={review} showFullReview={showFullReview} mobileWidth={false} />)}
				<LoadMoreFooter loading={loading} hasMore={hasMore} onLoadMore={onLoadMore} data-sentry-element="LoadMoreFooter" data-sentry-source-file="ReviewsDialogOrDrawer.tsx" />
			</DialogContent>
		</Dialog>;
}